import Flatten from "@flatten-js/core";

import type { CurveConfig, Edge } from "./types.ts";

const { point } = Flatten;

export const getXOffsetFactor = (edge: string) => (edge === "LEFT" ? -1 : edge === "RIGHT" ? 1 : 0);
export const getYOffsetFactor = (edge: string) => (edge === "TOP" ? -1 : edge === "BOTTOM" ? 1 : 0);

export const getControlPoint = (
  edge: Edge,
  refPoint: Flatten.Point,
  xControlDistance: number,
  yControlDistance: number,
) => {
  switch (edge) {
    case "TOP":
      return point(refPoint.x, refPoint.y - yControlDistance);

    case "BOTTOM":
      return point(refPoint.x, refPoint.y + yControlDistance);

    case "LEFT":
      return point(refPoint.x - xControlDistance, refPoint.y);

    case "RIGHT":
      return point(refPoint.x + xControlDistance, refPoint.y);
  }
};

export const defaultCurveConfig: CurveConfig = {
  fromPadding: 0, // or as below if double-headed
  toPadding: 12, // arrowSize + fromPadding.
  straight: 2,
  tension: 0.5,
  minControlDistance: 10,
  inOutGap: 8,
  arrowSize: 12,
  arrowGap: 0,
  dotSize: 4,
  showTouchables: false,
  touchableSize: 28,
  collapsedBendy: true,
};
